import { ERROR_MESSAGES, PASSWORD_MIN_CHARS, SIGN_IN_FAILED_MESSAGE } from '@rp/contracts'
import type { AuthErrorKind } from './client'

export const AUTH_COPY: Record<AuthErrorKind, string> = {
  invalid_credentials: SIGN_IN_FAILED_MESSAGE,
  weak_password: `密碼太弱，請用最少 ${PASSWORD_MIN_CHARS} 個字元`,
  too_many_attempts: ERROR_MESSAGES.RATE_LIMITED,
  network: '連線不到登入服務，請檢查網絡',
  unknown: '登入失敗，請稍後再試',
}

export const AUTH_FAILURE_COPY = {
  signOutNetwork: '登出失敗，請檢查網絡後再試一次',
  signOutUnknown: '登出失敗，請稍後再試',
  restoreUnknown: '暫時未能確認登入狀態，請稍後再試',
} as const

export const SIGN_IN_COPY = {
  title: '回覆助手',
  subtitle: '請以公司電郵登入',
  email: '電郵',
  password: '密碼',
  submit: '登入',
  submitting: '登入中…',
  signOut: '登出',
} as const
